export default __webpack_public_path__ + "09fae6a.png";